export default function FeaturesHighlight() {
  const features = [
    {
      icon: 'ri-4k-fill',
      title: '蓝光画质',
      desc: '支持4K超高清播放，每一帧都清晰动人，带来影院级的视觉享受',
    },
    {
      icon: 'ri-speed-up-fill',
      title: '极速播放',
      desc: '全球CDN加速节点，秒开不缓冲，流畅在线观看不卡顿',
    },
    {
      icon: 'ri-advertisement-line',
      title: '无广告',
      desc: '纯净观影体验，全程无广告打扰，沉浸式享受每一部电影',
    },
    {
      icon: 'ri-movie-fill',
      title: '电影大全',
      desc: '汇聚海量高清影视资源，涵盖各种类型，满足不同观影口味',
    },
    {
      icon: 'ri-device-line',
      title: '多端适配',
      desc: '支持电脑、平板、手机等多种设备，随时随地畅享观影',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全稳定',
      desc: '采用先进加密技术，保障观影安全，稳定运行不断线',
    },
  ];

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50">
              为什么选择天堂影院
            </h2>
            <p className="text-sm text-foreground-600 mt-1">六大优势，打造极致观影体验</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-300/40 hover:border-primary-500/20 transition-all duration-300 group"
              >
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-primary-100/70 mb-3 md:mb-4 group-hover:bg-primary-200/70 transition-colors duration-300">
                  <i className={`${feature.icon} text-primary-500 text-lg md:text-xl`}></i>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-200 mb-2">
                  {feature.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}